<template>
    <div class="page gc">
        <SideMenu />

        <div class="page-content g9">
            <h2 class="breadcrumb"><router-link :to="project.url">{{ project.title }}</router-link> {{ program.title }}</h2>

            <Accord :title="(isActives ? 'Active' : 'Archived') + ' studies'">
                <div class="grid-33w">
                    <ProjectTile :info="study" :key="study.studyId" v-for="study in program.studies.filter(x => x.isArchived == !isActives)"></ProjectTile>

                    <div class="tile tile-project tile-project-create" v-if="isActives && !program.isArchived">
                        <p v-on:click="onNewStudyClick">
                            Create study
                        </p>
                    </div>
                </div>
            </Accord>

            <form v-on:submit="onSaveSettingsSubmit" action="#" method="post" id="form" v-if="isActives && !program.isArchived">
                <FormBuilder :formData="settingsFormData" :formValue="program"></FormBuilder>

                <button class="right" v-bind:class="{ 'loading': isLoading }">Save</button>
            </form>
        </div>

        <Modal title="Create study" ref="modalNewStudy">
            <form v-on:submit="onNewStudySubmit">
                <div class="input" type="text">
                    <label>
                        <span>Name</span>
                        <input type="text" ref="studyNameInput" placeholder="New study name" v-model="newStudyName"/>
                    </label>
                </div>
                <template v-if="templates.length > 0 || statictemplates.length > 0">
                    <div class="input" type="select">
                        <label>
                            <span>Based on template</span>
                            <select v-model="newStudyTemplate">
                                <template v-if="statictemplates.length > 0">
                                    <option v-for="template in statictemplates"
                                            :value="template.fileName">
                                        {{template.name}}
                                    </option>
                                </template>
                                <template v-if="templates.length > 0">
                                    <option v-for="template in templates"
                                            :value="template.templateId">
                                        {{template.title}}
                                    </option>
                                </template>
                            </select>
                        </label>
                    </div>
                </template>
                    <button class="right edit" v-bind:class="{ 'loading': isLoading }">Create study</button>
</form>
        </Modal>
    </div>
</template>

<script>
    import SideMenu from "../Components/SideMenuStudies.vue"
    import Accord from "../Components/Accord.vue"
    import ProjectTile from "../Components/ProjectTile.vue"
    import Modal from "../Components/Modal.vue"
    import FormBuilder from "../Components/FormBuilder.vue"

    export default {
        components: {
            SideMenu,
            Accord,
            ProjectTile,
            Modal,
            FormBuilder
        },
        data: () => ({
            templates: [],
            statictemplates: [],
            newStudyName: null,
            newStudyTemplate: "DefaultStudyClean.json",
            isLoading: false,
            settingsFormData: [
                {
                    title: "General settings",
                    forms: [
                              {
                                  type: "select",
                                  extraClass: "input-w50",
                                  label: "Currency",
                                  value: "currency",
                                  preValues: "currency"
                              }
                            ]
                        }
                    ]               
        }),
        computed:{
            program(){
                return this.$store.getters.program(this.$route.params.id)
            },
            project(){
                return this.$store.getters.project(this.program.projectId)
            },
            isActives(){
                return this.$route.name == "studiesActive"
            }
        },
        mounted(){
            document.title = this.program.title + " › " + this.project.title;
            
            

            this.$store.dispatch("getStaticTemplatesList").then((res) => {
                this.statictemplates = res;
                
            });

            this.$store.dispatch("getTemplateList").then((res) => {                
                this.templates = res;
            });

        },
        methods: {
            onNewStudyClick() {
                this.$refs.modalNewStudy.show();
                this.$nextTick(() => this.$refs.studyNameInput.focus())
            },
            onNewStudySubmit(e) {
                e.preventDefault();

                this.isLoading = true;

                if(this.newStudyName == "")
                {
                    this.isLoading = false;
                    return false;
                }

                let newStudy = {
                    title: this.newStudyName,
                    template: this.newStudyTemplate,
                    parentId: this.program.programId
                };

                this.$store.dispatch("setStudy", newStudy).then((res) => {
                    this.$router.push(res.data.url)
                }).catch((res) => {
                    this.isLoading = false;
                })
            },
            onSaveSettingsSubmit (e) {
                e.preventDefault();

                let p = {
                    programId: this.program.programId,
                    currency: this.program.currency,
                    intervalValue: this.program.intervalValue,
                    intervalFormat: this.program.intervalFormat
                };

                this.$store.dispatch("settingsProgram", p).then((res) => {
                    this.isLoading = false;
                }).catch((res) => {
                    this.isLoading = false;
                })
            }
        }
    }
</script>
